import { throwError as observableThrowError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { FilterDepositeModel } from 'src/Models/CRRADepositeModel';

@Injectable({
  providedIn: 'root'
})
export class CrraDepositeMasterService {

  AppUrl = '';
  FilterDepositeModel = new FilterDepositeModel();
  constructor(private readonly _http: HttpClient) {
    this.setAPIUrl();
  }

  setAPIUrl() {
    if (sessionStorage.getItem('BaseURL') != null && sessionStorage.getItem('BaseURL') != '') {
      this.AppUrl = sessionStorage.getItem('BaseURL') || '';
    }
  }

  private handleError(error: HttpErrorResponse) {
    console.error(error.message || error);
    return observableThrowError(() => error.status);
  }

  GetAllDeposite(TokenKey: string, PageNumber: number, PageSize: number, stateId: string, filterText: string, orderBy: string): Observable<any> {
    this.FilterDepositeModel = {
      pageNumber: PageNumber,
      pageSize: PageSize,
      filterText,
      stateId,
      orderBy
    };
    this.setAPIUrl();
    const URL = this.AppUrl + 'api/CRRADepositeMaster/GetAllDeposite';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(URL, this.FilterDepositeModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  AddUpdateDeposite(TokenKey: string, addNewActionModel: any): Observable<any> {
    this.setAPIUrl();
    const URL = this.AppUrl + 'api/CRRADepositeMaster/AddUpdateDeposite';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(URL, addNewActionModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetDepositeById(TokenKey: string, payRateId: number): Observable<any> {
    this.setAPIUrl();
    const data = 'api/CRRADepositeMaster/GetDepositeById/' + payRateId ;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  DeleteDeposite(TokenKey: string, payRateId: number): Observable<any> {
    this.setAPIUrl();
    const data = 'api/CRRADepositeMaster/DeleteDeposite/' + payRateId ;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetDeposite(TokenKey: string): Observable<any> {
    this.setAPIUrl();
    const data = 'api/CRRADepositeMaster/GetDeposite';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetAllDepositByUser(TokenKey: string, PageNumber: number, PageSize: number, stateId: string, filterText: string, userId: number, OrderBy: string, isFavorite: number): Observable<any> {
    this.FilterDepositeModel = {
      pageNumber: PageNumber,
      pageSize: PageSize,
      filterText,
      stateId,
      orderBy: OrderBy,
      userId,
      isFavorite
    };
    this.setAPIUrl();
    const data = this.AppUrl + 'api/CRRADepositeMaster/GetAllDepositByUser';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(data, this.FilterDepositeModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetAllDepositeV2(TokenKey: string, PageNumber: number, PageSize: number, stateId: string, filterText: string, orderBy: string,_IsExport:boolean): Observable<any> {
    this.FilterDepositeModel = {
      pageNumber: PageNumber,
      pageSize: PageSize,
      filterText,
      stateId,
      orderBy,
      IsExport:_IsExport
    };
    this.setAPIUrl();
    const URL = this.AppUrl + 'api/CRRADepositeMaster/V2/GetAllDeposite';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(URL, this.FilterDepositeModel, httpOptions)
      .pipe(catchError(this.handleError));
  }
}
